<template>
  <v-container grid-list-md>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/">My Arlington -</router-link><router-link to="/digitalresources"> Digital Resources</router-link></h2>
        </div>
        <v-flex class="layer-page" v-if="alert">
        </v-flex>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <button type="button" class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu" :aria-expanded="mobileMenu ? 'true' : 'false'" aria-controls="filters-and-settings">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-minus"></use></svg>
                </button>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <button type="button" class="filter-header" @click="filtersToggle" v-show="!isMobile" :aria-expanded="filtersExpanded ? 'true' : 'false'" aria-controls="digital-resources-filter-list">
                            <span>Filters
                                <svg v-show="filtersExpanded" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!filtersExpanded" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-plus"></use></svg>
                                <span style="clear: both; display: block"></span>
                            </span>
                        </button>
                        <div id="digital-resources-filter-list" class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                            <div class="filter-item filter-category">Availability</div>
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Computer'" type="checkbox" @change="filterChange($event)"/>
                                <span class="tooltip"> <DesktopIcon title="Computer"/> Computer</span>
                                </label></div>
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'WiFi'" type="checkbox" @change="wifiChange($event)"/>
                                <span class="tooltip"> <WifiIcon title="Wi-Fi"/> Wi-Fi</span>
                                </label></div>
                            <div class="filter-item filter-item-nested" v-if="typeSelected.includes('WiFi')">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'IndoorWiFi'" type="checkbox" @change="wifiChange($event)"/>
                                <span class="tooltip"> <WifiIcon title="Wi-Fi"/> Indoor
                                  <span class="tooltiptext">Free public Wi-Fi available inside the facility.</span>
                                </span>
                                </label>
                            </div>
                            <div class="filter-item filter-item-nested" v-if="typeSelected.includes('WiFi')">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'DriveWiFi'" type="checkbox" @change="wifiChange($event)"/>
                                <span class="tooltip"> <WifiIcon class="wifi-icon-outdoor" title="Wi-Fi"/> Outdoor
                                  <span class="tooltiptext">Free public Wi-Fi available outside the facility.</span>
                                </span>
                                </label>
                            </div>
                            <!-- <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Training'" type="checkbox" />
                                <span class="tooltip"> Trainings</span>
                                </label></div> -->
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Printing'" type="checkbox" @change="filterChange($event)"/>
                                <span class="tooltip"> <PrinterIcon title="Printer"/> Printer</span>
                                </label></div>
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Scanning'" type="checkbox" @change="filterChange($event)"/>
                                <span class="tooltip">  <ScannerIcon title="Scanner"/> Scanner</span>
                                </label></div>

                          <div class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                            <div class="filter-item filter-category">Public Transit</div>
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Bus'" type="checkbox" @change="filterChange($event)"/>
                                <span class="tooltip"> <BusIcon title="Bus"/> Bus</span>
                                </label></div>
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Metro'" type="checkbox" @change="filterChange($event)"/>
                                <span class="tooltip"> <SubwayIcon title="Metro"/> Metro</span>
                                </label></div>
                          </div>
                        </div>
                    </div>

                    <h3>Zoom to Location</h3>
                    <div class="filter-container">
                        <label for="facility">Facility</label>
                        <br />
                        <div>
                            <select id="facility" v-model="facilitySelected" @change="facilityChange($event)">
                                <option value="">Select a facility</option>
                                <option v-for="f in facilities" :key="f" :value="f">{{f}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="filter-container">
                        <label for="facilitytype">Facility type</label>
                        <br />
                        <div>
                            <select id="facilitytype" v-model="facilityTypeSelected" @change="facilityChange($event)">
                                <option value="">Select a facility type</option>
                                <option v-for="f in facilityTypes" :key="f" :value="f">{{f}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete id="addressSearch" ref="autocomplete" @place_changed="placeChanged" placeholder="Enter street address"></gmap-autocomplete>
                    </div>
                    <div class="filter-container">
                        <label for="withinRadius">Within</label>
                        <br />
                        <div>
                            <select id="withinRadius" v-model="radiusSelected" :disabled="!selectedCoordinates">
                                <option value="">Set radius</option>
                                <option value="0.5">0.5 Mile</option>
                                <option value="1">1 Mile</option>
                            </select>
                        </div>
                        <span v-show="civicAssociationFailure">Unable to load Civic Assocations.</span>
                    </div>

                    <div class="filter-container">
                      <button class="link filter-header" @click="clearAll">Clear All</button>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window">
                <div style="position: relative; top: 0">
                  <div class="toggle-bar" role="group" aria-label="Map or list">
                    <button type="button" :class="showMap === true ? 'toggle-link' : 'toggle-link active'" :aria-pressed="showMap === true" @click="showMap = true">Map</button>
                    <button type="button" :class="showMap === false ? 'toggle-link' : 'toggle-link active'" :aria-pressed="showMap === false" @click="showMap = false" id="list-link">List</button>
                  </div>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    id="vue-map-container"
                    aria-label="Map of digital resource locations"
                    >
                    <gmap-marker v-for="digitalResource in filteredDigitalResources"
                      :key="digitalResource.Facility"
                      :position="digitalResource"
                      :icon="icon"
                      :options="shapeOptions"
                      @click="(e) => shapeClick(digitalResource, e)">
                    </gmap-marker>
                    <!-- Common Info Window -->
                    <gmap-info-window
                      :opened="selectedInfoWindowPosition !== null"
                      :position="selectedInfoWindowPosition"
                      @closeclick="infoWindowCloseClick">
                        <div class="info-window">
                          <div class="row">
                            <div class="header-column-left">
                              <h3 class="info-window-header"><b v-if="selectedItem.Facility" v-html="selectedItem.Facility" @click="openLink(selectedItem['Facility Website'])"></b><b v-else>Digital resource location</b></h3>
                            </div>
                            <div class="header-column-right">
                              <span v-if="selectedItem['Computers available?'] == 'Yes' || selectedItem['Wi-Fi'] == 'Yes' || selectedItem['Printing?'] == 'Yes' || selectedItem['Availability'] == 'Yes'">
                                <DesktopIcon title="Computer" v-if="selectedItem['Computers available?'] == 'Yes'" /> <WifiIcon title="Indoor Wi-Fi" v-if="selectedItem['Wi-Fi'] == 'Yes'" /> <WifiIcon class="wifi-icon-outdoor" title="Outdoor Wi-Fi" v-if="selectedItem['Availability'] == 'Yes'" /> <PrinterIcon title="Printer" v-if="selectedItem['Printing'] == 'Yes'" /> <ScannerIcon title="Scanner" v-if="selectedItem['Scanning'] == 'Yes'" />
                              </span>
                            </div>
                          </div>
                            <div class="row">
                              <div class="column">
                                <span>{{selectedItem['Street Address - Line 1']}}</span><br/>
                                <span>{{selectedItem['Phone Number']}}</span><br/>
                                <span class="transit-row"><BusIcon title="Bus" v-if="selectedItem['Bus'] == 'Yes'" /> <SubwayIcon title="Metro" v-if="selectedItem['Metro'] == 'Yes'" /></span><br/>
                              </div>
                              <div class="column">
                                <b v-if="selectedItem['Days of Operation'] && selectedItem['Days of Operation'] != 'N/A' && selectedItem['Hours'] && selectedItem['Hours'] != 'N/A'">Hours</b>
                                <ul class="operations-list" v-if="selectedItem['Days of Operation'] && selectedItem['Days of Operation'] != 'N/A' && selectedItem['Hours'] && selectedItem['Hours'] != 'N/A'">
                                  <li v-for="(day, index) in selectedItem['Days of Operation']" :key="day">{{day}}: {{selectedItem['Hours'][index]}}</li>
                                </ul>
                              </div>
                            </div><br/><br/>
                            <div class="info-window-body">
                              <!-- <span v-if="selectedItem['Computers available?'] == 'Yes' && selectedItem['Number of Computers']"><b>Number of Computers:</b> {{selectedItem['Number of Computers']}}<br/></span> -->
                              <span v-if="selectedItem['Specialty Software'] && selectedItem['Specialty Software'] != 'N/A'"><b>Specialty Software:</b> {{selectedItem['Specialty Software']}}<br/></span>
                              <span v-if="selectedItem['Accessibility'] && selectedItem['Accessibility'] != 'N/A'"><b>Accessibility Computers:</b> {{selectedItem['Accessibility']}}<br/></span>
                              <span v-if="selectedItem['Eligibility Requirements'] && selectedItem['Eligibility Requirements'] != 'N/A'"><b>Eligibility Requirements:</b> <span v-html="selectedItem['Eligibility Requirements']"></span><br/></span>
                              <span v-if="selectedItem['Printing'] == 'Yes'"><b>Printing Cost Per Page:</b> {{selectedItem['Printing Cost Per Page']}}<br/></span>
                              <span v-if="selectedItem['Reservations Needed?'] == 'Yes'"><b>Reservations Needed:</b> {{selectedItem['Reservations Needed?']}}<br/></span>
                              <span v-if="selectedItem['Reservations Needed?'] == 'Yes' && selectedItem['Reservation Requirements'] != 'N/A'"><b>Reservation Requirements:</b> <span v-html="selectedItem['Reservation Requirements']"></span><br/></span>
                              <span v-if="selectedItem['Assistance Languages'] && selectedItem['Assistance Languages'] != 'N/A'"><b>Assistance Languages:</b> {{selectedItem['Assistance Languages']}}<br/></span>
                              <span v-if="selectedItem['Trainings'] && selectedItem['Trainings'] != 'N/A'"><b>Trainings:</b> <span v-html="selectedItem['Trainings']"></span><br/></span>
                              <span v-if="selectedItem['Target Populations'] && selectedItem['Target Populations'] != 'N/A'"><b>Target Populations:</b> {{selectedItem['Target Populations']}}<br/></span>
                              <span v-if="selectedItem['Notes/comments'] && selectedItem['Notes/comments'] != 'N/A'"><b>Additional Information:</b> <span v-html="selectedItem['Notes/comments']"></span><br/></span>
                            </div>
                        </div>
                    </gmap-info-window>

                    <!-- Location Markers -->
                    <gmap-marker v-if="selectedCoordinates && !selectedCoordinates.fac" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <gmap-polygon v-if="civicAssocationsSelected" :path="civicAssocationsSelected.paths" :options="locationOptions"></gmap-polygon>
                    <GmapCircle v-if="selectedCoordinates && radiusSelected" :center="selectedCoordinates" :radius="radiusSelected*1609" :visible="true" :options="{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}"></GmapCircle>
                </gmap-map>
                <div v-show="!showMap" class="list-pane">
                  <div v-for="digitalResource in filteredDigitalResources" :key="digitalResource.Facility" class="project">
                    <div>
                      <div class="row">
                        <div class="list-header-column-left">
                          <h3 class="h3-list"><b v-if="digitalResource.Facility" v-html="digitalResource.Facility" @click="openLink(digitalResource['Facility Website'])"></b><b v-else>Digital resource location</b></h3>
                        </div>
                        <div class="list-header-column-right">
                          <span v-if="digitalResource['Computers available?'] == 'Yes' || digitalResource['Wi-Fi'] == 'Yes' || digitalResource['Printing?'] == 'Yes' || digitalResource['Availability'] == 'Yes'">
                            <DesktopIcon title="Computer" v-if="digitalResource['Computers available?'] == 'Yes'" /> <WifiIcon title="Indoor Wi-Fi" v-if="digitalResource['Wi-Fi'] == 'Yes'" /> <WifiIcon class="wifi-icon-outdoor" title="Outdoor Wi-Fi" v-if="digitalResource['Availability'] == 'Yes'" /> <PrinterIcon title="Printer" v-if="digitalResource['Printing'] == 'Yes'" /> <ScannerIcon title="Scanner" v-if="digitalResource['Scanning'] == 'Yes'" />
                            <br/>
                          </span>
                        </div>
                      </div>
                            <p class="no-vertical-margin">
                              <span>{{digitalResource['Street Address - Line 1']}}</span>
                              <span v-if="digitalResource['Phone Number']"><br/>{{digitalResource['Phone Number']}}</span><br/>
                              <span class="transit-row"><BusIcon title="Bus" v-if="digitalResource['Bus'] == 'Yes'" /> <SubwayIcon title="Metro" v-if="digitalResource['Metro'] == 'Yes'" /></span><br/>
                            </p><br/>
                            <p>
                              <b v-if="digitalResource['Days of Operation'] && digitalResource['Days of Operation'] != 'N/A' && digitalResource['Hours'] && digitalResource['Hours'] != 'N/A'">Hours</b>
                              <ul class="operations-list" v-if="digitalResource['Days of Operation'] && digitalResource['Days of Operation'] != 'N/A' && digitalResource['Hours'] && digitalResource['Hours'] != 'N/A'">
                                <li v-for="(day, index) in digitalResource['Days of Operation']" :key="day">{{day}}: {{digitalResource['Hours'][index]}}</li>
                              </ul>
                            </p><br/>
                        <p class="no-vertical-margin">
                        <!-- <span v-if="digitalResource['Computers available?'] == 'Yes' && digitalResource['Number of Computers']"><b>Number of Computers:</b> {{digitalResource['Number of Computers']}}<br/></span> -->
                        <span v-if="digitalResource['Specialty Software'] && digitalResource['Specialty Software'] != 'N/A'"><b>Specialty Software:</b> {{digitalResource['Specialty Software']}}<br/></span>
                        <span v-if="digitalResource['Accessibility'] && digitalResource['Accessibility'] != 'N/A'"><b>Accessibility Computers:</b> {{digitalResource['Accessibility']}}<br/></span>
                        <span v-if="digitalResource['Eligibility Requirements'] && digitalResource['Eligibility Requirements'] != 'N/A'"><b>Eligibility Requirements:</b> <span v-html="digitalResource['Eligibility Requirements']"></span><br/></span>
                        <span v-if="digitalResource['Printing'] == 'Yes'"><b>Printing Cost Per Page:</b> {{digitalResource['Printing Cost Per Page']}}<br/></span>
                        <span v-if="digitalResource['Reservations Needed?'] == 'Yes'"><b>Reservations Needed:</b> {{digitalResource['Reservations Needed?']}}<br/></span>
                        <span v-if="digitalResource['Reservations Needed?'] == 'Yes' && digitalResource['Reservation Requirements'] != 'N/A'"><b>Reservation Requirements:</b> <span v-html="digitalResource['Reservation Requirements']"></span><br/></span>
                        <span v-if="digitalResource['Assistance Languages'] && digitalResource['Assistance Languages'] != 'N/A'"><b>Assistance Languages:</b> {{digitalResource['Assistance Languages']}}<br/></span>
                        <span v-if="digitalResource['Trainings'] && digitalResource['Trainings'] != 'N/A'"><b>Trainings:</b> <span v-html="digitalResource['Trainings']"></span><br/></span>
                        <span v-if="digitalResource['Target Populations'] && digitalResource['Target Populations'] != 'N/A'"><b>Target Populations:</b> {{digitalResource['Target Populations']}}<br/></span>
                        <span v-if="digitalResource['Notes/comments'] && digitalResource['Notes/comments'] != 'N/A'"><b>Additional Information:</b> <span v-html="digitalResource['Notes/comments']"></span><br/></span>
                        </p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </v-container>
</template>

<script>
import R from 'ramda';
import geolib from 'geolib';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapGetters, mapActions } from 'vuex';
import ScannerIcon from 'vue-material-design-icons/scanner.vue'
import PrinterIcon from 'vue-material-design-icons/printer.vue'
import WifiIcon from 'vue-material-design-icons/wifi.vue'
import DesktopIcon from 'vue-material-design-icons/desktop-classic.vue'
import BusIcon from 'vue-material-design-icons/bus.vue'
import SubwayIcon from 'vue-material-design-icons/subway-variant.vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
})

export default {
  name: 'digitalResources',
  components: {
    ScannerIcon,
    PrinterIcon,
    WifiIcon,
    DesktopIcon,
    BusIcon,
    SubwayIcon
  },
  data () {
    return {
      alert: true,
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      civicAssocationsSelected: '',
      facilitySelected: '',
      facilityTypeSelected: '',
      civicAssociationFailure: false,
      filterQuery: {},
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 } // eslint-disable-line no-undef
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: []
    }
  },
  computed: {
    ...mapGetters(['digitalResources']),
    zoomLevel: function () {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      if (this.civicAssocationsSelected) {
        const civicCenter = geolib.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }

      return this.center;
    },
    facilities: function () {
      return [...new Set(this.digitalResources.map(item => item.Facility))];
    },
    facilityTypes: function () {
      let types = [...new Set(this.digitalResources.map(item => item['Facility Type']))];
      types.sort();
      return types
    },
    filteredDigitalResources: function () {
      var _dr = this.digitalResources
      if (this.typeSelected && this.typeSelected.length > 0) {
        if (this.typeSelected.includes('Computer')) {
          this.filterQuery.Computer = true;
          _dr = _dr.filter(f => f['Computers available?'] === 'Yes')
        }
        if (this.typeSelected.includes('IndoorWiFi') && this.typeSelected.includes('DriveWiFi')) {
          _dr = _dr.filter(f => f['Wi-Fi'] === 'Yes')
        }
        if (!this.typeSelected.includes('DriveWiFi') && this.typeSelected.includes('IndoorWiFi')) {
          _dr = _dr.filter(f => f['Wi-Fi'] === 'Yes')
        }
        if (this.typeSelected.includes('DriveWiFi') && !this.typeSelected.includes('IndoorWiFi')) {
          _dr = _dr.filter(f => f['Availability'] === 'Yes')
        }
        if (this.typeSelected.includes('Training')) {
          _dr = _dr.filter(f => f['Trainings'] !== null && f['Trainings'] !== 'No' && f['Trainings'] !== 'N/A')
        }
        if (this.typeSelected.includes('Printing')) {
          this.filterQuery.Printing = true;
          _dr = _dr.filter(f => f['Printing'] === 'Yes')
        }
        if (this.typeSelected.includes('Scanning')) {
          this.filterQuery.Scanning = true;
          _dr = _dr.filter(f => f['Scanning'] === 'Yes')
        }
        if (this.typeSelected.includes('Bus')) {
          this.filterQuery.Bus = true;
          _dr = _dr.filter(f => f['Bus'] === 'Yes')
        }
        if (this.typeSelected.includes('Metro')) {
          this.filterQuery.Metro = true;
          _dr = _dr.filter(f => f['Metro'] === 'Yes')
        }
      }
      if (this.facilitySelected) {
        _dr = _dr.filter(f => f.Facility === this.facilitySelected)
      }
      if (this.facilityTypeSelected) {
        _dr = _dr.filter(f => f['Facility Type'] === this.facilityTypeSelected)
      }
      if (this.selectedCoordinates && this.radiusSelected) {
        _dr.map(m => {
          m.distance = geolib.getDistance({ latitude: this.selectedCoordinates.lat, longitude: this.selectedCoordinates.lng }, { latitude: m.lat, longitude: m.lng })
        })
        _dr = _dr.filter(f => this.radiusSelected * 1609 >= f.distance)
      }
      this.$router.push({query: this.filterQuery});
      return _dr
    }
  },
  beforeMount: function () {
    this.typeSelected = Object.getOwnPropertyNames(this.$route.query)
    this.typeSelected.forEach(a => {
      if (a === 'facility' || a === 'facilitytype') {
        return
      }
      this.filterQuery[a] = true;
    })

    this.filterQuery.facility = this.$route.query.facility || '';
    this.filterQuery.facilitytype = this.$route.query.facilitytype || '';
    if (!this.$route.query.facility || this.$route.query.facility === '') {
      delete this.filterQuery.facility
    }
    if (!this.$route.query.facilitytype || this.$route.query.facilitytype === '') {
      delete this.filterQuery.facilitytype
    }
  },
  mounted: function () {
    this.loadDigitalResources().then(() => {
      this.facilitySelected = this.filterQuery.facility || '';
      this.facilityTypeSelected = this.filterQuery.facilitytype || '';
    });

    this.isMobile = window.innerWidth < 600;
  },
  watch: {
    statusesSelected () {
      this.infoWindowCheck();
    },
    projectTypesSelected () {
      this.infoWindowCheck();
    },
    facilitySelected () {
      if (this.facilitySelected && this.filteredDigitalResources.length > 0) {
        this.setLocation(this.filteredDigitalResources[0].lat, this.filteredDigitalResources[0].lng, true);
      } else {
        this.selectedCoordinates = null;
      }
    }
  },
  methods: {
    ...mapActions(['loadDigitalResources']),
    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },
    wifiChange: function (ev) {
      if (this.typeSelected.includes('WiFi')) {
        this.filterQuery.WiFi = true;
        if (this.typeSelected.includes('IndoorWiFi')) {
          this.filterQuery.IndoorWiFi = true;
        }
        if (this.typeSelected.includes('DriveWiFi')) {
          this.filterQuery.DriveWiFi = true;
        }
      } else {
        this.typeSelected = this.typeSelected.filter(a => a !== 'IndoorWiFi' && a !== 'DriveWiFi')
        delete this.filterQuery['DriveWiFi']
        delete this.filterQuery['IndoorWiFi']
      }
      this.filterChange(ev);
    },
    filterChange: function (ev) {
      if (!this.typeSelected.includes(ev.srcElement.value)) {
        delete this.filterQuery[ev.srcElement.value]
      }
      this.$router.push({query: this.filterQuery});
    },
    facilityChange: function (ev) {
      this.filterQuery[ev.srcElement.id] = ev.srcElement.value
      if (!ev.srcElement.value || ev.srcElement.value === '') {
        delete this.filterQuery[ev.srcElement.id]
      }
      this.$router.push({query: this.filterQuery});
    },
    clearAll () {
      this.subStatusesSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.typeSelected = [];
      this.selectedCoordinates = null;
      this.facilitySelected = '';
      this.facilityTypeSelected = '';
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
      this.filterQuery = {};
    },
    placeChanged: function (place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function (lat, lng, facility) {
      this.selectedCoordinates = { lat: lat, lng: lng, fac: facility };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick (parentStatus) {
      var statusValues = R.map(R.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(s => {
        const i = this.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          this.subStatusesSelected.splice(i, 1);
        }
      });
    },
    openLink (link) {
      window.open(link, '_blank');
    },
    openCovidPage () {
      window.open('https://www.arlingtonva.us/covid-19/operational-status/', '_blank');
    }
  }
}

</script>

<style lang="scss" scoped>
    .filter-category {
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

.operations-list {
  li {
    font-size: 1em;
    padding: 0px;
  }
}

.h3-list {
  margin: 0px;
}

.column {
  float: left;
  width: 50%;
  min-width: 145px;
  min-height: 55px;
}

.info-window-header {
  margin: 0px;
}

.info-window-body {
  clear: both;
}

.header-column-left {
  float: left;
  width: 75%;
  min-height: 30px;
}

.header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 30px;
  margin-bottom: 3px;
  height: auto;
  span {
    font-size: 20px;
  }
}

.list-header-column-left {
  float: left;
  width: 75%;
  min-height: 25px;
}

.list-header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 25px;
  margin-bottom: 1px;
  height: auto;
  span {
    font-size: 20px;
    margin-top: 6px;
  }
}

.row:after {
  display: table;
  clear: both;
}

.transit-row {
  font-size: 20px;
}

.filter-item-nested {
  margin-left: 10px;
}

.wifi-icon-outdoor {
  color: #5ab155;
}

#dr-alert  {
  padding: 9px 16px;
  min-height: 35px;
  background-color: #e38410;
  border: 0px;
  width: 100%;
}

.error {
  background-color: #e38410 !important;
}

@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// digitalResources.vue?18c43332